import { render, staticRenderFns } from "./SampleMain.vue?vue&type=template&id=0c7e19c1"
import script from "./SampleMain.vue?vue&type=script&lang=js"
export * from "./SampleMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports